import { ModalContext } from "app/app";
import axios from "axios";
import { IconedButton } from "components/IconedButton";
import { Pagination } from "components/Pagination";
import { Animate, Grid, Search, Table, ViewContext } from "components/lib";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styles from "./styles.module.scss";

export function Contacts(props) {
  const { id: company_id } = useParams();
  const [payload, setPayload] = useState();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [searchQueryString, setSearchQueryString] = useState("");

  const { setModal } = useContext(ModalContext);
  const context = useContext(ViewContext);

  async function runAPI(page, search) {
    setLoading(true);

    await axios
      .get(
        `/api/contact?page=${page}&search=${search}&company_id=${company_id}`
      )
      .then((res) => {
        setLoading(false);
        setPayload(res.data.data);

        var tempData = [];

        res.data.data.data.map((value, index) => {
          tempData.push({
            id: value.id,
            name: value.name,
            email: value.email,
            phone: value.phone,
            notes: value.notes,
          });
        });

        setData(tempData);
      })
      .catch((err) => {
        setLoading(false);

        context.notification.show(
          "Failed to load table data",
          "error",
          true,
          "toast",
          "x-circle"
        );
      });
  }

  useEffect(() => {
    runAPI(page, searchQueryString);
  }, [searchQueryString]);

  useEffect(() => {
    runAPI(page, "");
  }, []);

  function editContact(contact) {
    setModal({
      name: "contact_modal",
      data: contact,
      mode: "edit",
      action: () => runAPI(payload.page, searchQueryString),
    });
  }

  function deleteContact(contact) {
    setModal({
      name: "confirmation",
      data: {
        title: `Delete a contact`,
        description: `Do you really want to delete the contact "${contact.name}"?`,
      },
      action: async () => {
        setModal("");

        await axios
          .delete(`/api/contact/${contact.id}`)
          .then((res) => {
            setModal("");
            runAPI(page, searchQueryString);
          })
          .catch((err) => {
            setLoading(false);

            context.notification.show(
              "Failed to load table data",
              "error",
              true,
              "toast",
              "x-circle"
            );
          });
      },
    });
  }

  return (
    <Animate type="pop">
      <div
        style={{
          display: "flex",
          alignContent: "center",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex" }}>
          <div
            onClick={() => {
              window.location.href = "/app/company/" + company_id + "/info";
            }}
            style={{
              backgroundColor: "#EAEAEA",
              width: "150px",
              color: "#090E3480",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 10,
              fontSize: 16,
              fontWeight: 600,
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10,
              cursor: "pointer",
            }}
          >
            Company
          </div>

          <div
            style={{
              backgroundColor: "black",
              color: "#fff",
              width: "150px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 10,
              fontSize: 16,
              fontWeight: 600,
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10,
              cursor: "default",
            }}
          >
            Contacts
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            width: "150px",
          }}
        >
          <IconedButton
            size="140px"
            color="#d32425"
            textColor="white"
            icon="plus-circle"
            text="Add Contact"
            action={() =>
              setModal({
                name: "contact_modal",
                action: () => runAPI(page, searchQueryString),
              })
            }
          />
        </div>
      </div>
      <Grid cols="1">
        <div className={styles.card}>
          <div style={{ marginBottom: 30 }}>
            <Search
              callback={(query) => {
                setSearchQueryString(query);
              }}
            />
          </div>
          <Table
            loading={loading}
            data={payload && payload.data ? data : null}
            badge={{ col: "type", color: "gray" }}
            hide={["link", "id"]}
            actions={{
              custom: [
                {
                  icon: "edit",
                  tooltip: "Edit this contact",
                  action: (row) => {
                    editContact(row);
                  },
                },
                {
                  icon: "trash",
                  tooltip: "Delete this contact",
                  action: (row) => {
                    deleteContact(row);
                  },
                },
              ],
            }}
          />
          {payload && (
            <Pagination
              pagesCount={payload.pages_count}
              active={payload.page}
              onChange={async (newPage) => {
                setPage(newPage);
                runAPI(newPage, searchQueryString);
              }}
            />
          )}
        </div>
      </Grid>
    </Animate>
  );
}
